export interface CountryFormat {
  name: string;
  code: string;
  firestoreId: string; // ID utilisé dans Firestore
  flag: string;
  dimensions: {
    width: number;
    height: number;
    unit: 'mm' | 'inches';
  };
  background: string;
  requirements: string[];
}

export const countries: CountryFormat[] = [
  {
    name: 'United States',
    code: 'US',
    firestoreId: 'usa',
    flag: '🇺🇸',
    dimensions: { width: 2, height: 2, unit: 'inches' },
    background: 'White or off-white',
    requirements: ['Face directly facing camera', 'Neutral expression', 'Eyes open', 'Plain white or off-white background']
  },
  {
    name: 'Canada',
    code: 'CA',
    firestoreId: 'canada',
    flag: '🇨🇦',
    dimensions: { width: 50, height: 70, unit: 'mm' },
    background: 'Plain white',
    requirements: ['Neutral expression', 'Both eyes visible', 'No glasses', 'Plain white background']
  },
  {
    name: 'France',
    code: 'FR',
    firestoreId: 'france',
    flag: '🇫🇷',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light grey or white',
    requirements: ['Face must be 32-36mm', 'Neutral expression', 'No smile', 'Light background']
  },
  {
    name: 'United Kingdom',
    code: 'GB',
    firestoreId: 'uk',
    flag: '🇬🇧',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light grey or cream',
    requirements: ['Face centered', 'Neutral expression', 'No smiling', 'Plain light background']
  },
  {
    name: 'Germany',
    code: 'DE',
    firestoreId: 'germany',
    flag: '🇩🇪',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light grey',
    requirements: ['Face 32-36mm', 'Looking straight ahead', 'Neutral expression', 'Light background']
  },
  {
    name: 'Australia',
    code: 'AU',
    firestoreId: 'australia',
    flag: '🇦🇺',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light grey or white',
    requirements: ['Face centered', 'Neutral expression', 'No smile', 'Plain background']
  },
  {
    name: 'Japan',
    code: 'JP',
    firestoreId: 'japan',
    flag: '🇯🇵',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Plain light color',
    requirements: ['Face 32-36mm', 'Neutral expression', 'No glasses reflection', 'Plain background']
  },
  {
    name: 'India',
    code: 'IN',
    firestoreId: 'india',
    flag: '🇮🇳',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face 25-35mm', 'Both ears visible', 'Neutral expression', 'White background']
  },
  {
    name: 'Spain',
    code: 'ES',
    firestoreId: 'spain',
    flag: '🇪🇸',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light grey or white',
    requirements: ['Face centered', 'Neutral expression', 'No smile', 'Light background']
  },
  {
    name: 'Italy',
    code: 'IT',
    firestoreId: 'italy',
    flag: '🇮🇹',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face 32-36mm', 'Neutral expression', 'No glasses', 'White background']
  },
  {
    name: 'Brazil',
    code: 'BR',
    firestoreId: 'brazil',
    flag: '🇧🇷',
    dimensions: { width: 50, height: 70, unit: 'mm' },
    background: 'White',
    requirements: ['Face centered', 'Neutral expression', 'Both eyes visible', 'White background']
  },
  {
    name: 'China',
    code: 'CN',
    firestoreId: 'china',
    flag: '🇨🇳',
    dimensions: { width: 33, height: 48, unit: 'mm' },
    background: 'White or light blue',
    requirements: ['Face 28-33mm', 'Neutral expression', 'No heavy makeup', 'Plain background']
  },
  {
    name: 'Netherlands',
    code: 'NL',
    firestoreId: 'netherlands',
    flag: '🇳🇱',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face centered', 'Neutral expression', 'Eyes open', 'White background']
  },
  {
    name: 'Belgium',
    code: 'BE',
    firestoreId: 'belgium',
    flag: '🇧🇪',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light background (not white)',
    requirements: ['Face centered', 'Neutral expression', 'No smile', 'Light background']
  },
  {
    name: 'Switzerland',
    code: 'CH',
    firestoreId: 'switzerland',
    flag: '🇨🇭',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face 32-36mm', 'Neutral expression', 'Eyes open', 'White background']
  },
  {
    name: 'Sweden',
    code: 'SE',
    firestoreId: 'sweden',
    flag: '🇸🇪',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light',
    requirements: ['Face centered', 'Neutral expression', 'No smile', 'Plain background']
  },
  {
    name: 'Norway',
    code: 'NO',
    firestoreId: 'norway',
    flag: '🇳🇴',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light',
    requirements: ['Face centered', 'Neutral expression', 'Eyes open', 'Plain background']
  },
  {
    name: 'Denmark',
    code: 'DK',
    firestoreId: 'denmark',
    flag: '🇩🇰',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Gray',
    requirements: ['Face centered', 'Neutral expression', 'No smile', 'Gray background']
  },
  {
    name: 'Poland',
    code: 'PL',
    firestoreId: 'poland',
    flag: '🇵🇱',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face 32-36mm', 'Neutral expression', 'Eyes visible', 'White background']
  },
  {
    name: 'Portugal',
    code: 'PT',
    firestoreId: 'portugal',
    flag: '🇵🇹',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face centered', 'Neutral expression', 'No smile', 'White background']
  },
  {
    name: 'Austria',
    code: 'AT',
    firestoreId: 'austria',
    flag: '🇦🇹',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light',
    requirements: ['Face 32-36mm', 'Neutral expression', 'Eyes open', 'Light background']
  },
  {
    name: 'Ireland',
    code: 'IE',
    firestoreId: 'ireland',
    flag: '🇮🇪',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light gray or white',
    requirements: ['Face centered', 'Neutral expression', 'No smile', 'Light background']
  },
  {
    name: 'Finland',
    code: 'FI',
    firestoreId: 'finland',
    flag: '🇫🇮',
    dimensions: { width: 36, height: 47, unit: 'mm' },
    background: 'Light',
    requirements: ['Face centered', 'Neutral expression', 'Eyes open', 'Plain background']
  },
  {
    name: 'Romania',
    code: 'RO',
    firestoreId: 'romania',
    flag: '🇷🇴',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face centered', 'Neutral expression', 'No smile', 'White background']
  },
  {
    name: 'South Korea',
    code: 'KR',
    firestoreId: 'south-korea',
    flag: '🇰🇷',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face 32-36mm', 'Neutral expression', 'Eyes open', 'White background']
  },
  {
    name: 'Thailand',
    code: 'TH',
    firestoreId: 'thailand',
    flag: '🇹🇭',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face centered', 'Neutral expression', 'No smile', 'White background']
  },
  {
    name: 'Malaysia',
    code: 'MY',
    firestoreId: 'malaysia',
    flag: '🇲🇾',
    dimensions: { width: 35, height: 50, unit: 'mm' },
    background: 'White',
    requirements: ['Face centered', 'Neutral expression', 'Eyes visible', 'White background']
  },
  {
    name: 'Singapore',
    code: 'SG',
    firestoreId: 'singapore',
    flag: '🇸🇬',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light',
    requirements: ['Face centered', 'Neutral expression', 'No glasses (unless medical)', 'Light background']
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
    firestoreId: 'uae',
    flag: '🇦🇪',
    dimensions: { width: 40, height: 60, unit: 'mm' },
    background: 'White',
    requirements: ['Face 70% of photo', 'Neutral expression', 'Eyes open', 'White background']
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
    firestoreId: 'saudi-arabia',
    flag: '🇸🇦',
    dimensions: { width: 4, height: 6, unit: 'inches' },
    background: 'White',
    requirements: ['Face centered', 'Traditional dress allowed', 'Neutral expression', 'White background']
  },
  {
    name: 'Turkey',
    code: 'TR',
    firestoreId: 'turkey',
    flag: '🇹🇷',
    dimensions: { width: 50, height: 60, unit: 'mm' },
    background: 'White',
    requirements: ['Face centered', 'Neutral expression', 'Head not tilted', 'White background']
  },
  {
    name: 'Israel',
    code: 'IL',
    firestoreId: 'israel',
    flag: '🇮🇱',
    dimensions: { width: 50, height: 50, unit: 'mm' },
    background: 'White',
    requirements: ['Face centered', 'Neutral expression', 'Eyes open', 'White background']
  },
  {
    name: 'Egypt',
    code: 'EG',
    firestoreId: 'egypt',
    flag: '🇪🇬',
    dimensions: { width: 40, height: 60, unit: 'mm' },
    background: 'White',
    requirements: ['Face 38-39.9mm', 'Neutral expression', 'No smile', 'White background']
  },
  {
    name: 'South Africa',
    code: 'ZA',
    firestoreId: 'south-africa',
    flag: '🇿🇦',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face 29-34mm', 'Neutral expression', 'Eyes visible', 'White background']
  },
  {
    name: 'Kenya',
    code: 'KE',
    firestoreId: 'kenya',
    flag: '🇰🇪',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face centered', 'Neutral expression', 'No smile', 'White background']
  },
  {
    name: 'Mexico',
    code: 'MX',
    firestoreId: 'mexico',
    flag: '🇲🇽',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'White',
    requirements: ['Face 30-36mm', 'Neutral expression', 'Eyes open', 'White background']
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    firestoreId: 'new-zealand',
    flag: '🇳🇿',
    dimensions: { width: 35, height: 45, unit: 'mm' },
    background: 'Light (blue, gray, cream)',
    requirements: ['Portrait 4:3 ratio', 'Neutral expression', 'No white clothing', 'Light background']
  }
];
